<div class="modal fade" id="filtersModal" tabindex="-1" role="dialog" aria-labelledby="filtersModal" aria-hidden="true">
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="btn-close"
					(click)="filtersClose()"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<div class="mb-3">
					<div class="row g-2">
						<div class="form-floating col-md">
							<input
								type="date"
								class="form-control"
								name="date_from"
								[(ngModel)]="filters.date_from"
								id="date_from"
							/>
							<label for="date_from" class="form-label">Od</label>
						</div>
						<div class="form-floating col-md">
							<input
								type="date"
								class="form-control"
								name="date_to"
								[(ngModel)]="filters.date_to"
								id="date_to"
							/>
							<label for="date_to" class="form-label">Do</label>
						</div>
					</div>
					<div class="mb-3">
						<label class="form-label" for="drivers">Pracownik</label>
						<ng-select
							id="drivers"
							name="drivers"
							[(ngModel)]="filters.drivers"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of drivers" [value]="item.id">{{ item.name }} </ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="settlementBonusNameIds">Dodatek/Potrącenie</label>
						<ng-select
							id="settlementBonusNameIds"
							name="settlementBonusNameIds"
							[(ngModel)]="filters.settlementBonusNameIds"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option
								*ngFor="let settlementBonusNameIds of settlementBonusNameIds"
								[value]="settlementBonusNameIds.id"
								>{{ settlementBonusNameIds.name }}</ng-option
							>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="isSettled">Rozliczono</label>
						<ng-select
							id="isSettled"
							name="isSettled"
							[(ngModel)]="filters.isSettled"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let isSettled of isSettled" [value]="isSettled.id">{{
								isSettled.name
							}}</ng-option>
						</ng-select>
					</div>
				</div>
				<div class="modal-footer">
					<div class="btn-group me-auto">
						<button type="button" class="btn btn-danger" (click)="filtersClear()">Wyczyść</button>
					</div>
					<div class="btn-group">
						<button type="button" class="btn btn-primary" (click)="filtersSave()">Pokaż</button>
						<button type="button" class="btn btn-secondary" (click)="filtersClose()">Anuluj</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
